// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ROOT VARIABLES
 * Define common values for easy maintenance.
 */
:root {
  --primary-color: #1890ff;
  --primary-color-dark: #438f90;
  --light-gray: #f9f9f9;
  --medium-gray: #eee;
  --dark-gray: #303030;
  --text-color-dark: #333;
  --text-color-light: #fff;
  --text-color-medium: #666;
  --success-color: #5cb85c;
  --pending-color: #f0ad4e;
  --border-radius: 12px;
  --shadow-base: 0 4px 12px rgba(0, 0, 0, 0.1);
  --shadow-hover: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/*
 * VIEW ORDERS PAGE LAYOUT
 * Sets the main layout for the orders page and grid container.
 */
.cart-page {
    padding: 1px 10px;
    max-width: 100%;
    margin: 80px 10px;
    font-family: 'Segoe UI', sans-serif;
    min-height: 100vh;
}

.cart-page h1 {
    font-size: 1.2rem;
    text-align: center;
    margin: 40px;
    color: white; /* Changed to dark text color */
    font-family: 'GlitchGoblin', sans-serif;
}

.empty-cart {
    text-align: center;
    font-size: 1.25rem;
    color: #888;
    padding: 2rem 0;
}

.cart-items {
    display: flex;
    flex-direction: column;
    gap: 1.3rem;
    margin: 20px 10px;
}

.cart-item-card {
    display: flex;
    align-items: stretch;
    position: relative;
    background: #ffffff; /* Changed to white */
    border-radius: 16px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    height: 120px;
}

.cart-devide-item-card {
    display: flex;
    background-color: #f8f8f8; /* Changed to light gray for distinction */
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
    font-family: 'Segoe UI', sans-serif;
    align-items: stretch;
}

.cart-column {
    text-align: center;
    font-size: 14px;
    color: black; /* Changed to dark gray */
    padding: 10px;
}

.cart-column:last-child {
    border-right: none;
}

.product-col {
    text-align: center;
    width: 26%;
}

.price-col {
    text-align: center;
    width: 15%;
}

.variant-col {
    text-align: center;
    width: 15%;
}

.quantity-col {
    text-align: center;
    width: 18%;
}

.cart-item-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.1);
}

/* ✅ New: Square Image Wrapper */
.cart-image-wrapper {
    aspect-ratio: 1 / 1;
    background-color: #f2f2f2;
    flex-shrink: 0;
    height: auto;
    display: flex;
    align-items: stretch;
}

.cart-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.cart-item-details {
    flex: 1 1;
    padding: 1rem 2.25rem;
    display: flex;
}

.product-title {
    font-size: 1.2rem;
    margin: 0rem;
    color: var(--text-color-dark); /* Changed to dark text color */
    display: flex;
    align-items: center;
    font-weight: 700;
    width: 17%;
}

.cart-price {
    font-size: 1.1rem;
    font-weight: 700;
    color: #007bff;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    width: 20%;
    justify-content: center;
}

.quantity-controls {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
}

.quantity-controls button {
    width: 32px;
    height: 32px;
    font-size: 1.1rem;
    font-weight: bold;
    background-color: #f1f3f5;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
}

.quantity-controls button:hover:not(:disabled) {
    background-color: #e0e0e0;
}

.quantity-controls span {
    font-size: 1.1rem;
    min-width: 30px;
    text-align: center;
    color: #000000; /* Changed to black */
}

.cart-item-details h3 {
    font-size: 1.2rem;
    margin: 0rem;
    color: var(--text-color-dark); /* Changed to dark text color */
}

.cart-item-details p {
    margin: 0.3rem 0;
}

.duration-label {
    color: var(--text-color-dark); /* Changed to dark text color */
    display: flex;
    align-items: center;
}

.stock-info {
    color: #888; /* Adjusted color for better contrast */
    display: flex;
    align-items: center;
}

.cart-item-bottom-row {
    width: 23%;
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
}

/* X Button on top-right */
.remove-btn {
    position: absolute;
    top: 8px;
    left: 91.5%;
    width: 25px;
    height: 25px;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    border-radius: 50%;
    background-color: red;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
    z-index: 10;
}

.undo_button {
    display: inline-block;
    margin-left: 12px;
    padding: 6px 14px;
    font-size: 0.875rem;
    font-weight: 600;
    color: #ffffff;
    background: linear-gradient(135deg, #4f46e5, #3b82f6);
    border: none;
    border-radius: 999px;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
    backdrop-filter: blur(2px);
}

.undo_button:hover {
    transform: scale(1.05);
    background: linear-gradient(135deg, #4338ca, #2563eb);
    box-shadow: 0 6px 18px rgba(37, 99, 235, 0.4);
}

.undo_button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.4);
}

@media (min-width: 769px) {
    .remove-btn {
        position: absolute;
        top: 8px;
        left: 97.5%;
        margin: -4px;
    }
}

.remove-btn:hover {
    background-color: #e64949;
}

.cart-summary-section {
    position: sticky;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 35px 10px;
    gap: 1rem;
    flex-wrap: wrap;
    z-index: 10;
    bottom: 0;
    border: 1px solid #ccc; /* Changed border color */
    padding: 10px;
    border-radius: 15px;
    background: #e3e3e3; /* Changed to white */
}

.cart-info-card {
    background-color: white; /* Changed to light gray */
    padding: 1rem 1.5rem;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    min-width: 200px;
    flex: 1 1;
    text-align: center;
}

.cart-info-card h3 {
    font-size: 1.1rem;
    color: var(--text-color-dark); /* Changed to dark text color */
    margin: 0rem 0.5rem;
}

.cart-info-card p {
    font-size: 1.3rem;
    font-weight: 700;
    color: #007bff;
    margin: 0;
}

.checkout-btn {
    background-color: #007bff;
    color: #fff;
    padding: 0.9rem 2rem;
    font-size: 1.2rem;
    font-weight: 600;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.checkout-btn:hover {
    background-color: #007bff;
    transform: translateY(-2px);
}

.variant-select {
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 14px;
    border: 1px solid #ccc;
    background: transparent;
    color: black; /* Changed to black */
}

.variant-select-wrapper {
    margin-top: 5px;
    display: flex;
    align-items: center;
    width: 21%;
    justify-content: center;
}

.variant-select option {
    color: black; /* Changed to black */
    background: white; /* Changed to white */
}

.saving-cart-text {
    text-align: center;
    color: #666;
    margin-top: 1rem;
    font-style: italic;
}

.quantity-controls button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.stock-info.low-stock {
    color: red;
    font-weight: 500;
}

/* Mobile Styles */
@media (max-width: 768px) {
    .cart-page {
        padding: 20px 5px;
        margin: 80px 10px;
    }
    
    .cart-page h1 {
        font-size: 23px;
        margin: 0px;
        padding: 0px;
    }
    
    .cart-items {
        margin: 20px 0px;
    }
    
    .checkout-btn {
        margin-top: 1rem;
        width: 100%;
    }
    
    .cart-item-details {
        flex-direction: column;
        padding: 0.5rem 1rem;
    }
    
    .cart-item-bottom-row {
        position: absolute;
        top: 60px;
        right: 20px;
        gap: 7px;
    }
    
    .cart-devide-item-card {
        display: none;
    }
    
    .variant-select-wrapper {
        justify-content: normal;
    }

    .cart-item-card {
        margin: 10px 10px;
        height: 130px;
    }

}
`, "",{"version":3,"sources":["webpack://./src/components/AddToCart.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;;;EAGE;AACF;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY,EAAE,+BAA+B;IAC7C,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB,EAAE,qBAAqB;IAC1C,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,qDAAqD;IACrD,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB,EAAE,0CAA0C;IACrE,mBAAmB;IACnB,sCAAsC;IACtC,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY,EAAE,yBAAyB;IACvC,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,gCAAgC;AAChC;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,6BAA6B,EAAE,+BAA+B;IAC9D,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,cAAc,EAAE,qBAAqB;AACzC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,6BAA6B,EAAE,+BAA+B;AAClE;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B,EAAE,+BAA+B;IAC9D,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,uCAAuC;IACpD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qDAAqD;IACrD,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,0BAA0B;IAC1B,8CAA8C;IAC9C,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI;QACI,kBAAkB;QAClB,QAAQ;QACR,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,WAAW;IACX,SAAS;IACT,sBAAsB,EAAE,yBAAyB;IACjD,aAAa;IACb,mBAAmB;IACnB,mBAAmB,EAAE,qBAAqB;AAC9C;;AAEA;IACI,uBAAuB,EAAE,0BAA0B;IACnD,oBAAoB;IACpB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B,EAAE,+BAA+B;IAC9D,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAE,qBAAqB;AACvC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,YAAY,EAAE,qBAAqB;IACnC,iBAAiB,EAAE,qBAAqB;AAC5C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;;AAEJ","sourcesContent":["/*\n * ROOT VARIABLES\n * Define common values for easy maintenance.\n */\n:root {\n  --primary-color: #1890ff;\n  --primary-color-dark: #438f90;\n  --light-gray: #f9f9f9;\n  --medium-gray: #eee;\n  --dark-gray: #303030;\n  --text-color-dark: #333;\n  --text-color-light: #fff;\n  --text-color-medium: #666;\n  --success-color: #5cb85c;\n  --pending-color: #f0ad4e;\n  --border-radius: 12px;\n  --shadow-base: 0 4px 12px rgba(0, 0, 0, 0.1);\n  --shadow-hover: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n/*\n * VIEW ORDERS PAGE LAYOUT\n * Sets the main layout for the orders page and grid container.\n */\n.cart-page {\n    padding: 1px 10px;\n    max-width: 100%;\n    margin: 80px 10px;\n    font-family: 'Segoe UI', sans-serif;\n    min-height: 100vh;\n}\n\n.cart-page h1 {\n    font-size: 1.2rem;\n    text-align: center;\n    margin: 40px;\n    color: white; /* Changed to dark text color */\n    font-family: 'GlitchGoblin', sans-serif;\n}\n\n.empty-cart {\n    text-align: center;\n    font-size: 1.25rem;\n    color: #888;\n    padding: 2rem 0;\n}\n\n.cart-items {\n    display: flex;\n    flex-direction: column;\n    gap: 1.3rem;\n    margin: 20px 10px;\n}\n\n.cart-item-card {\n    display: flex;\n    align-items: stretch;\n    position: relative;\n    background: #ffffff; /* Changed to white */\n    border-radius: 16px;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n    overflow: hidden;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    height: 120px;\n}\n\n.cart-devide-item-card {\n    display: flex;\n    background-color: #f8f8f8; /* Changed to light gray for distinction */\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.05);\n    font-family: 'Segoe UI', sans-serif;\n    align-items: stretch;\n}\n\n.cart-column {\n    text-align: center;\n    font-size: 14px;\n    color: black; /* Changed to dark gray */\n    padding: 10px;\n}\n\n.cart-column:last-child {\n    border-right: none;\n}\n\n.product-col {\n    text-align: center;\n    width: 26%;\n}\n\n.price-col {\n    text-align: center;\n    width: 15%;\n}\n\n.variant-col {\n    text-align: center;\n    width: 15%;\n}\n\n.quantity-col {\n    text-align: center;\n    width: 18%;\n}\n\n.cart-item-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.1);\n}\n\n/* ✅ New: Square Image Wrapper */\n.cart-image-wrapper {\n    aspect-ratio: 1 / 1;\n    background-color: #f2f2f2;\n    flex-shrink: 0;\n    height: auto;\n    display: flex;\n    align-items: stretch;\n}\n\n.cart-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n.cart-item-details {\n    flex: 1;\n    padding: 1rem 2.25rem;\n    display: flex;\n}\n\n.product-title {\n    font-size: 1.2rem;\n    margin: 0rem;\n    color: var(--text-color-dark); /* Changed to dark text color */\n    display: flex;\n    align-items: center;\n    font-weight: 700;\n    width: 17%;\n}\n\n.cart-price {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #007bff;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    width: 20%;\n    justify-content: center;\n}\n\n.quantity-controls {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin: 0;\n}\n\n.quantity-controls button {\n    width: 32px;\n    height: 32px;\n    font-size: 1.1rem;\n    font-weight: bold;\n    background-color: #f1f3f5;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.quantity-controls button:hover:not(:disabled) {\n    background-color: #e0e0e0;\n}\n\n.quantity-controls span {\n    font-size: 1.1rem;\n    min-width: 30px;\n    text-align: center;\n    color: #000000; /* Changed to black */\n}\n\n.cart-item-details h3 {\n    font-size: 1.2rem;\n    margin: 0rem;\n    color: var(--text-color-dark); /* Changed to dark text color */\n}\n\n.cart-item-details p {\n    margin: 0.3rem 0;\n}\n\n.duration-label {\n    color: var(--text-color-dark); /* Changed to dark text color */\n    display: flex;\n    align-items: center;\n}\n\n.stock-info {\n    color: #888; /* Adjusted color for better contrast */\n    display: flex;\n    align-items: center;\n}\n\n.cart-item-bottom-row {\n    width: 23%;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: column;\n}\n\n/* X Button on top-right */\n.remove-btn {\n    position: absolute;\n    top: 8px;\n    left: 91.5%;\n    width: 25px;\n    height: 25px;\n    font-size: 1rem;\n    font-weight: bold;\n    border: none;\n    border-radius: 50%;\n    background-color: red;\n    color: white;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s ease;\n    z-index: 10;\n}\n\n.undo_button {\n    display: inline-block;\n    margin-left: 12px;\n    padding: 6px 14px;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #ffffff;\n    background: linear-gradient(135deg, #4f46e5, #3b82f6);\n    border: none;\n    border-radius: 999px;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);\n    backdrop-filter: blur(2px);\n}\n\n.undo_button:hover {\n    transform: scale(1.05);\n    background: linear-gradient(135deg, #4338ca, #2563eb);\n    box-shadow: 0 6px 18px rgba(37, 99, 235, 0.4);\n}\n\n.undo_button:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.4);\n}\n\n@media (min-width: 769px) {\n    .remove-btn {\n        position: absolute;\n        top: 8px;\n        left: 97.5%;\n        margin: -4px;\n    }\n}\n\n.remove-btn:hover {\n    background-color: #e64949;\n}\n\n.cart-summary-section {\n    position: sticky;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 35px 10px;\n    gap: 1rem;\n    flex-wrap: wrap;\n    z-index: 10;\n    bottom: 0;\n    border: 1px solid #ccc; /* Changed border color */\n    padding: 10px;\n    border-radius: 15px;\n    background: #e3e3e3; /* Changed to white */\n}\n\n.cart-info-card {\n    background-color: white; /* Changed to light gray */\n    padding: 1rem 1.5rem;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n    min-width: 200px;\n    flex: 1;\n    text-align: center;\n}\n\n.cart-info-card h3 {\n    font-size: 1.1rem;\n    color: var(--text-color-dark); /* Changed to dark text color */\n    margin: 0rem 0.5rem;\n}\n\n.cart-info-card p {\n    font-size: 1.3rem;\n    font-weight: 700;\n    color: #007bff;\n    margin: 0;\n}\n\n.checkout-btn {\n    background-color: #007bff;\n    color: #fff;\n    padding: 0.9rem 2rem;\n    font-size: 1.2rem;\n    font-weight: 600;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.checkout-btn:hover {\n    background-color: #007bff;\n    transform: translateY(-2px);\n}\n\n.variant-select {\n    padding: 6px 10px;\n    border-radius: 6px;\n    font-size: 14px;\n    border: 1px solid #ccc;\n    background: transparent;\n    color: black; /* Changed to black */\n}\n\n.variant-select-wrapper {\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    width: 21%;\n    justify-content: center;\n}\n\n.variant-select option {\n    color: black; /* Changed to black */\n    background: white; /* Changed to white */\n}\n\n.saving-cart-text {\n    text-align: center;\n    color: #666;\n    margin-top: 1rem;\n    font-style: italic;\n}\n\n.quantity-controls button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.stock-info.low-stock {\n    color: red;\n    font-weight: 500;\n}\n\n/* Mobile Styles */\n@media (max-width: 768px) {\n    .cart-page {\n        padding: 20px 5px;\n        margin: 80px 10px;\n    }\n    \n    .cart-page h1 {\n        font-size: 23px;\n        margin: 0px;\n        padding: 0px;\n    }\n    \n    .cart-items {\n        margin: 20px 0px;\n    }\n    \n    .checkout-btn {\n        margin-top: 1rem;\n        width: 100%;\n    }\n    \n    .cart-item-details {\n        flex-direction: column;\n        padding: 0.5rem 1rem;\n    }\n    \n    .cart-item-bottom-row {\n        position: absolute;\n        top: 60px;\n        right: 20px;\n        gap: 7px;\n    }\n    \n    .cart-devide-item-card {\n        display: none;\n    }\n    \n    .variant-select-wrapper {\n        justify-content: normal;\n    }\n\n    .cart-item-card {\n        margin: 10px 10px;\n        height: 130px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
